import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { UserControllerService } from "../services/user-controller.service";

export const authGuard: CanActivateFn = (route, state) => {
  const userControllerService = inject(UserControllerService);
  const router = inject(Router);
  return Boolean(userControllerService.user()) || router.createUrlTree(['/401']);
};